import React from "react";
import { SpaceShape } from "venuescanner-js/react/shapes";

const Capacity = ({ space }) => (
  <div className="space-tile__capacity">
    <span>{space.capacity} capacity</span>
  </div>
);

Capacity.propTypes = {
  space: SpaceShape.isRequired,
};

export default Capacity;
